import { render, staticRenderFns } from "./PoliciesPagination.vue?vue&type=template&id=24577b69&"
import script from "./PoliciesPagination.vue?vue&type=script&lang=js&"
export * from "./PoliciesPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports